// «Artículos que pueden ayudar» en los detalles del caso: busca en la base de conocimiento con el titulo y las etiquetas
// del caso (basta una palabra; el servidor ordena por relevancia) y muestra los 3 primeros. Si no hay, no se muestra.
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';

import { buscarSugeridos } from '../../api/conocimiento';
import { Icon } from '../../lib/icons';

export function ArticulosSugeridos({ titulo, etiquetas }: { titulo: string; etiquetas: string[] }) {
  // Las etiquetas internas (unido, zammad...) no describen el problema.
  const q = [titulo, ...etiquetas.filter((e) => !['unido', 'zammad'].includes(e.toLowerCase()))].join(' ').trim();
  const r = useQuery({ queryKey: ['kb-sugeridos', q], queryFn: ({ signal }) => buscarSugeridos(q, signal), enabled: q.length >= 4, staleTime: 5 * 60_000, retry: false });
  const lista = (r.data ?? []).slice(0, 3);
  if (!lista.length) return null;
  return (
    <div className="caso-kb" aria-label="Artículos que pueden ayudar">
      <span className="caso-etq-t">Artículos que pueden ayudar</span>
      {lista.map((a) => (
        <Link key={a.id} to={`/bandeja/conocimiento?articulo=${a.id}`} className="caso-kb-it" title={a.resumen ?? a.titulo}>
          <Icon name="book" size={14} />
          <span>
            <b>{a.titulo}</b>
            <small>{a.categoria}</small>
          </span>
        </Link>
      ))}
    </div>
  );
}
